"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useRouter } from "next/navigation";
import { CircleChevronLeft } from "lucide-react";

import UniversalSearchInput from "../../common/search/UniversalSearchInput";
import SearchResultsList from "../../../components/townlitOfficial/search/SearchResultsList";

import { useAppDispatch } from "../../../redux/hooks";
import {
  searchOfficialVideosThunk,
  getVideoCategories,
  getVideoSeries,
} from "../../../redux/main/mainSlice";

import "./HeaderOfficialControls.css";

const HeaderOfficialControls = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    dispatch(getVideoCategories());
    dispatch(getVideoSeries());
  }, [dispatch]);

  const handleBack = () => router.back();

  const handleSearch = (query: string) => {
    dispatch(searchOfficialVideosThunk({ search: query }));
  };

  if (!mounted) return null;

  return createPortal(
    <div className="header-official-portal">
      <div className="header-official-controls-container">
        <button
          className="header-back-button"
          onClick={handleBack}
          title="Go Back"
        >
          <CircleChevronLeft size={28} strokeWidth={1.4} />
        </button>

        <UniversalSearchInput
          placeholder="Search TownLIT Official"
          position="right"
          onSearch={handleSearch}
          renderResults={(query: string) =>
            query.length > 1 ? <SearchResultsList query={query} /> : null
          }
        />
      </div>
    </div>,
    document.body
  );
};

export default HeaderOfficialControls;
